import React from 'react';
import { Hero } from './components/Hero';
import { OpeningHook } from './components/OpeningHook';
import { Problem } from './components/Problem';
import { WhyItFailed } from './components/WhyItFailed';
import { ThermalFlip } from './components/ThermalFlip';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoItsFor } from './components/WhoItsFor';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-night-900 font-sans selection:bg-amber-500/30 selection:text-amber-200" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <OpeningHook data-id="element-3" />
        <Problem data-id="element-4" />
        <WhyItFailed data-id="element-5" />
        <ThermalFlip data-id="element-6" />
        <WhatYouGet data-id="element-7" />
        <WhoItsFor data-id="element-8" />
        <HowItWorks data-id="element-9" />
        <Proof data-id="element-10" />
        <FAQ data-id="element-11" />
        <FinalCTA data-id="element-12" />
      </main>

      <Footer data-id="element-13" />
    </div>;
}